// Feedback revision 2026-10-03
(() => {
  'use strict';
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function authoredHeadings() {
    const breaks={
      'AI moved forward. The desk didn’t.':['AI moved forward.','The desk didn’t.'],
      'Touch. AI. MASS OS. Expansion.':['Touch. AI. MASS OS.','Expansion.'],
      'One system. Every Mini App.':['One system.','Every Mini App.'],
      'No screws. No drivers. No restart.':['No screws.','No drivers. No restart.'],
      'Full technical specifications.':['Full technical','specifications.'],
      'One system. Endless possibilities.':['One system.','Endless possibilities.'],
      'Choose your MASS X.':['Choose your','MASS X.']
    };
    document.querySelectorAll('.chapter-heading h2').forEach(el=>{
      const value=el.dataset.authoredText||el.textContent.trim().replace(/\s+/g,' ');
      el.dataset.authoredText=value;
      el.replaceChildren();
      (innerWidth<768&&breaks[value]?breaks[value]:[value]).forEach((line,i)=>{if(i)el.append(document.createElement('br'));el.append(document.createTextNode(line));});
    });
  }
  window.mxAuthoredHeadings=authoredHeadings;
  function fitCanvas() {
    authoredHeadings();
    const width=document.documentElement.clientWidth,mobile=innerWidth<768;
    const dw=mobile?390:1440,viewportHeight=window.visualViewport?.height||innerHeight;
    const homeHeight=mobile?788:900,normal=width/dw;
    const html=document.documentElement;
    const mode=document.querySelector('#home')?.dataset.homeLayout||'full-width';
    html.dataset.homeLayout=mode;
    html.style.setProperty('--home-bottom-space','0px');
    const navigationScale=Math.min(normal,viewportHeight/(homeHeight+44));
    const storeCanvas=document.querySelector('.mxw-store-canvas');
    if(storeCanvas){
      const path=document.body.dataset.mxPath||location.pathname;
      const longPage=/^\/(?:collections(?:\/|$)|search(?:\/|$)|policies(?:\/|$)|products(?:\/|$))/.test(path)||document.body.classList.contains('roshi-page-article');
      document.body.classList.toggle('mxw-scroll-page',longPage);
      const naturalHeight=Math.max(storeCanvas.offsetHeight,storeCanvas.scrollHeight);
      const storeScale=longPage?Math.min(normal,1):Math.min(normal,(viewportHeight-16)/(naturalHeight+44));
      html.style.setProperty('--store-canvas-scale',String(storeScale));
    }
    const headerHeight=44*navigationScale,available=Math.max(1,viewportHeight-headerHeight);
    html.style.setProperty('--preview-scale',String(navigationScale));
    html.style.setProperty('--navigation-height',`${headerHeight}px`);
    html.style.setProperty('--module-view-height',`${available}px`);
    html.style.setProperty('--home-scale',String(mode==='full-width'?normal:Math.min(normal,available/homeHeight)));
    if(!storeCanvas){
      document.querySelectorAll('.mxw-page .shopify-section').forEach(section=>{
        const canvas=section.querySelector(':scope > .design-content,:scope > #home');
        if(!canvas)return;
        if(canvas.id==='home'&&(mode==='full-width'||canvas.hasAttribute('data-mx-scroll-hero'))){
          section.classList.remove('mxw-fit-section');
          section.style.removeProperty('--canvas-scale');
          return;
        }
        const nativeExperience=!!canvas.querySelector('.mxe-scroll-enhanced');
        const nativeSpecs=mobile&&!!canvas.querySelector('.mxw-specifications');
        const nativeReading=!!canvas.querySelector('[data-mx-reading]')||(mobile&&!!canvas.querySelector('#progress,#about,#faq'));
        section.classList.toggle('mxw-native-mobile-experience',nativeExperience);
        section.classList.toggle('mxw-native-specs',nativeSpecs);
        if(nativeExperience||nativeSpecs||nativeReading){
          section.classList.remove('mxw-fit-section');
          section.style.removeProperty('--canvas-scale');
          return;
        }
        const height=Math.max(canvas.offsetHeight,canvas.scrollHeight);
        if(!height){section.classList.remove('mxw-fit-section');return;}
        section.classList.add('mxw-fit-section');
        const scale=Math.min(normal,available/Math.max(1,height));
        section.style.setProperty('--canvas-scale',String(scale));
        section.dataset.fitHeight=String(height);
      });
      const footer=document.querySelector('footer.roshi-footer'),section=footer?.closest('.shopify-section');
      if(section){
        section.classList.add('mxw-screen-footer');
        const height=Math.max(footer.offsetHeight,footer.scrollHeight);
        section.style.setProperty('--canvas-scale',String(Math.min(normal,available/Math.max(1,height))));
      }
    }
  }
  function mediaController(root, cleanups) {
    const videos=[...root.querySelectorAll('video:not([data-exp-video]):not(.mxw-boot-video)')];
    if(!videos.length)return;
    const visible=new Set(), manuallyPaused=new WeakSet();
    function allowed(v) {
      if(document.hidden||!visible.has(v)||v.closest('[hidden],[aria-hidden="true"],.os-panel:not(.is-visible),.feature-media-layer:not(.is-visible)'))return false;
      if(v.closest('.morph-crop')&&+(v.closest('.morph-crop').style.opacity||1)<.08)return false;
      if(v.closest('.morph-detail')&&+(v.closest('.morph-detail').style.opacity||0)<.1)return false;
      return !!(v.offsetWidth&&v.offsetHeight);
    }
    function refresh() {
      videos.forEach(v=>{
        if(!allowed(v)){if(!v.paused)v.pause();return;}
        if(v.dataset.autoplay==='true'&&!reduced.matches&&!manuallyPaused.has(v)&&v.paused)v.play().catch(()=>{});
      });
    }
    videos.forEach(v=>{
      v.muted=true;v.playsInline=true;
      // Inline motion has no player chrome. Click or keyboard activation pauses it.
      // Respect reduced motion without silently restoring native playback controls.
      if(!v.controls){
        const description=v.getAttribute('aria-label')||'Product demonstration';
        v.dataset.inlineMotion='true';v.tabIndex=0;v.setAttribute('role','button');
        const label=()=>v.setAttribute('aria-label',`${v.paused?'Play':'Pause'} animation: ${description}`);
        const toggle=()=>{if(v.paused){manuallyPaused.delete(v);v.play().catch(()=>{});}else{manuallyPaused.add(v);v.pause();}};
        const key=e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}};
        v.addEventListener('click',toggle);v.addEventListener('keydown',key);
        v.addEventListener('play',label);v.addEventListener('pause',label);label();
        cleanups.push(()=>{v.removeEventListener('click',toggle);v.removeEventListener('keydown',key);v.removeEventListener('play',label);v.removeEventListener('pause',label);});
      }
      v.addEventListener('pause',()=>{if(allowed(v)&&!v.ended)manuallyPaused.add(v);});
      v.addEventListener('play',()=>manuallyPaused.delete(v));
    });
    const io=new IntersectionObserver(entries=>{entries.forEach(e=>e.isIntersecting?visible.add(e.target):visible.delete(e.target));refresh();},{threshold:.08});
    videos.forEach(v=>io.observe(v));
    const observer=new MutationObserver(refresh);
    observer.observe(root,{attributes:true,subtree:true,attributeFilter:['class','aria-hidden','hidden']});
    const sync=setInterval(()=>{
      refresh();
      const slices=videos.filter(v=>v.classList.contains('morph-image'));
      if(slices.length>1&&!slices[0].paused)slices.slice(1).forEach(v=>{if(Number.isFinite(v.duration)&&Math.abs(v.currentTime-slices[0].currentTime)>.08)v.currentTime=slices[0].currentTime;});
    },400);
    document.addEventListener('visibilitychange',refresh);
    reduced.addEventListener('change',refresh);
    cleanups.push(()=>{io.disconnect();observer.disconnect();clearInterval(sync);document.removeEventListener('visibilitychange',refresh);reduced.removeEventListener('change',refresh);videos.forEach(v=>v.pause());});
  }
  function header(root, cleanup) {
    const toggle=root.querySelector('.menu-toggle'),menu=root.querySelector('.mobile-menu');
    if(!toggle||!menu)return;
    const close=()=>{menu.hidden=true;toggle.setAttribute('aria-expanded','false');};
    toggle.onclick=()=>{menu.hidden=!menu.hidden;toggle.setAttribute('aria-expanded',String(!menu.hidden));};
    menu.onclick=e=>{if(e.target.closest('a'))close();};
    const key=e=>{if(e.key==='Escape')close();},outside=e=>{if(!root.contains(e.target))close();};
    document.addEventListener('keydown',key);document.addEventListener('click',outside);
    const desktop=matchMedia('(min-width:1100px)');
    desktop.addEventListener('change',close);
    cleanup.push(()=>{document.removeEventListener('keydown',key);document.removeEventListener('click',outside);desktop.removeEventListener('change',close);});
  }
  function simpleCarousel(root,cleanup) {
    const panels=[...root.querySelectorAll('[data-panel]')],dots=[...root.querySelectorAll('[data-slide]')];
    let active=0;
    if(!panels.length)return;
    function select(i){
      const next=(i+panels.length)%panels.length,direction=i<active?-1:1;
      if(next===active)return;
      active=next;
      panels.forEach((p,n)=>p.hidden=n!==active);
      dots.forEach((d,n)=>d.setAttribute('aria-current',String(n===active)));
      root.dataset.slide=String(active);
      if(!reduced.matches)panels[active].animate([{opacity:0,transform:`translateX(${direction*20}px)`},{opacity:1,transform:'translateX(0)'}],{duration:420,easing:'cubic-bezier(.22,.75,.2,1)'});
    }
    dots.forEach((b,i)=>b.onclick=()=>select(i));
    root.querySelectorAll('[data-step]').forEach(b=>b.onclick=()=>select(active+(+b.dataset.step)));
    root.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();select(active+(e.key==='ArrowRight'?1:-1));}});
    if(root.id==='connection')MxMotion.wireSwipe(root.querySelector('.slide-body'),step=>select(active+step),cleanup);
    root.mxSelect=select;
  }

  function mount(container) {
    if(instances.has(container))unmount(container);
    const cleanup=[];instances.set(container,cleanup);
    const root=container.querySelector('[data-mx-section]')||container.querySelector('#header');
    if(!root)return;
    if(root.id==='header')header(root,cleanup);
    if(root.id==='experience')MxMotion.wireExperience(root,cleanup);
    if(root.id==='mass-os')MxMotion.wireMassOS(root,cleanup);
    if(root.id==='modules')MxMotion.wireExtensions(root,cleanup);
    if(root.classList.contains('carousel'))simpleCarousel(root,cleanup);
    if(root.id==='home'){
      const copy=root.querySelector('.hero-copy');
      if(copy){const observer=new ResizeObserver(fitCanvas);observer.observe(copy);cleanup.push(()=>observer.disconnect());}
      document.fonts.ready.then(()=>{if(root.isConnected)fitCanvas();});
    }
    mediaController(root,cleanup);
  }
  function unmount(container){(instances.get(container)||[]).forEach(fn=>fn());instances.delete(container);}
  function mountStoreContent() {
    if(location.pathname==='/pages/mass80-downloads'){
      const content=document.querySelector('.roshi-page-content'),source=content?.querySelector('a');
      if(source&&!content.querySelector('.mxw-download-cta')){const button=source.cloneNode(true);button.className='mxw-primary mxw-download-cta';button.append(document.createTextNode(' ↗'));content.append(button);}
    }
    document.querySelectorAll('.roshi-product-details').forEach(detail=>{
      const preview=detail.querySelector('[data-description-preview]'),full=detail.querySelector('[data-description-full]'),trigger=detail.querySelector('summary');
      if(full){trigger.setAttribute('aria-expanded','false');trigger.addEventListener('click',event=>{event.preventDefault();const expanded=full.hidden;full.hidden=!expanded;preview.hidden=expanded;trigger.setAttribute('aria-expanded',String(expanded));});}
    });
    // Shopify policies keep their original link targets and content.
    // Whitespace substitutes hidden authoring line breaks without joining words.
    document.querySelectorAll('.shopify-policy__body br,.roshi-product-description br').forEach(br=>br.before(document.createTextNode(' ')));
  }
  function observeFitContent() {
    let scheduled=0;
    const refresh=()=>{cancelAnimationFrame(scheduled);scheduled=requestAnimationFrame(fitCanvas);};
    const observer=new ResizeObserver(refresh);
    document.querySelectorAll('.mxw-store-canvas,.design-content,#home,footer.roshi-footer').forEach(el=>observer.observe(el));
    document.fonts.ready.then(refresh);
    window.visualViewport?.addEventListener('resize',refresh);
  }
  function boot(){mountStoreContent();fitCanvas();observeFitContent();document.querySelectorAll('.mxw-section,.mxw-header-section').forEach(mount);}
  window.addEventListener('resize',fitCanvas);
  document.addEventListener('shopify:section:load',e=>{fitCanvas();mount(e.target);});
  document.addEventListener('shopify:section:unload',e=>unmount(e.target));
  document.addEventListener('shopify:section:reorder',()=>window.dispatchEvent(new Event('resize')));
  document.addEventListener('shopify:block:select',e=>{
    const root=e.target.closest('[data-mx-section]');
    if(!root?.mxSelect)return;
    let index=-1;
    if(root.id==='experience')index=[...root.querySelectorAll('.feature-item')].indexOf(e.target.closest('.feature-item'));
    else if(root.id==='mass-os')index=[...root.querySelectorAll('.os-panel')].indexOf(e.target.closest('.os-panel'));
    else if(root.id==='modules')index=2;
    else index=[...root.querySelectorAll('[data-panel]')].indexOf(e.target.closest('[data-panel]'));
    if(index>=0)root.mxSelect(index);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
